import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';


import { adminDashboard, checkifLeadsReceived } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { Chart, registerables } from 'chart.js';


const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

const optionsN = {
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }],

    }
}

class partnerDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          school_data: [],
          allowedtoacess:false,
          haveleads:false,
          totalleads:0
        };
    }

    componentDidMount() {

        let dataOfUser = this.state.auth_data;
        let allowedtoacess = (dataOfUser.upgraded==1)?true:(dataOfUser.current_plan!=5 && dataOfUser.current_plan!=0 && dataOfUser.current_plan!=1)?true:false;

        let req = {
            url: 'school_data'
        };

        adminDashboard(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
                this.setSchoolChart(response.result);
            }
        });
      
        this.setState({allowedtoacess:allowedtoacess, user_name:this.state.auth_data.user_name, role:this.state.auth_data.role});   


        req.url = 'like_follow_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setLike(response.result);
            }
        });


        req.url = 'vistors_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setVisitors(response.result);
            }
        });

        if(dataOfUser.role===3){
            this.checkifLeadsReceived();
        }

    }

    checkifLeadsReceived(){

        let insdata = JSON.stringify({
          vendor_id: this.state.auth_data.login_id
        })
    
        checkifLeadsReceived(insdata).then((response) => {
          if (response.status === 1) {
            if(response.total>0)
              this.setState({haveleads:true, totalleads:response.total});   
            else
              this.setState({haveleads:false});  
          }
          
        });
  
      }        

    setVisitors = (data) => {

        var ctx = document.getElementById('barChartVisitors');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }    

    setLike = (data) => {

        var ctx = document.getElementById('barChartLikeFollows');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }

    setAfterschoolChart = (data) => {

        var ctx = document.getElementById('afterschoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }    

    setTuitionChart = (data) => {

        var ctx = document.getElementById('tuitionChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setSchoolChart = (data) => {

        var ctx = document.getElementById('schoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setPreschoolChart = (data) => {

        var ctx = document.getElementById('preschoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    } 


    setcampChart = (data) => {

        var ctx = document.getElementById('campChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setcommunityChart = (data) => {

        var ctx = document.getElementById('communityChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setbirthdayChart = (data) => {

        var ctx = document.getElementById('birthdayChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }        


    render() {

        return (
          <React.Fragment>
          <AdminLayout>
                    
            <div class="row  mt-3">
              {!this.state.allowedtoacess && this.state.haveleads && 
                <div class="col-xl-12 d-flex grid-margin stretch-card">
                    <div class="leadtemptinfo blinking">You have <span>{this.state.totalleads} lead(s)</span> new prospect(s) in your account. Please subscribe and reach out to them directly.</div>
                </div>
              }

              {this.state.allowedtoacess && this.state.haveleads && 
                <div class="col-xl-12 d-flex grid-margin stretch-card">
                    <div class="leadtemptinfo blinking">You have new <span>{this.state.totalleads} prospect(s)</span></div>
                </div>
              }

              {this.state.auth_data.fresher==1 &&
              
              <div class="fresh_partner_notification">

                    Welcome, This is your fresh account, Please fill in <a href="/partner/accountinfo/">Account info</a> and submit for approval so that you can see your institution in our respective listings.

              </div>
              
              
              }

              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                    <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'} >
                        <div class="d-flex flex-wrap justify-content-between">
                        <h4 class="card-title mb-3">Visitors</h4>
                        
                        </div>
                        <div class="row">
                        <div class="col-12">
                            <canvas id="barChartVisitors"></canvas>
                        </div>
                        </div>
                    </div>
                </div>
              </div>

             

              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                    {!this.state.allowedtoacess &&
                    <div class="overlay"><span>Please subscribe or upgrade</span></div> 
                    }
                  <div className={!this.state.allowedtoacess? "card-body blurred":'card-body'}>
                    <div class="d-flex flex-wrap justify-content-between">
                      <h4 class="card-title mb-3">Likes & Follows</h4>
                      
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <canvas id="barChartLikeFollows"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default partnerDashboard;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/dashboard.jsx